// extracted by mini-css-extract-plugin
module.exports = {"seperator":"seperator-module--seperator--2XJDU"};